/**
 * Main theme entry point
 * Initializes all global dependencies including lazy loading, carousels, custom elements, cart, and search
 */

import LazyLoad, { ILazyLoadInstance } from 'vanilla-lazyload'

import 'flickity'
import 'flickity/dist/flickity.min.css'

import 'styles/theme.scss'

import '@/components/custom-elements/registerCustomElements'

import { session } from '../helpers/session'

declare global {
  interface Window {
    Session: typeof session;
    lazyLoadInstance: ILazyLoadInstance;
  }
}

window.Session = session
window.lazyLoadInstance = new LazyLoad()
window.lazyLoadInstance.update()
